<template>
  <div id="app">
    <bgm></bgm>
    <!-- <p @click="testWeiXin">{{ msg }}</p> -->
    <router-view />
  </div>
</template>
<script>
import bgm from '@/components/bgm'

import { appID, host } from './assets/js/baseConfig'

export default {
  data() {
    return {
      msg: '',
      appID: appID,
      host: host,
      // 点击授权后重定向url地址
      redirectUrl: `/xcross/test`
    }
  },
  components: {
    bgm: bgm
  },
  created() {
    // if (this.isWeiXin()) {
    //   this.msg = '微信浏览器'
    // } else {
    //   this.msg = '非微信浏览器'
    // }
  },
  mounted() {
    window.addEventListener(
      'hashchange',
      () => {
        var currentPath = window.location.hash.slice(1) // 获取输入的路由
        if (this.$router.path !== currentPath) {
          this.$router.push(currentPath) // 动态跳转
        }
      },
      false
    )
  },
  methods: {
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase()
      console.log(ua)
      if (ua.match(/MicroMessenger/i).length > 0) {
        return true
      } else {
        return false
      }
    },
    testWeiXin() {
      // 微信授权api,接口返回code,点击授权后跳转到重定向地址并带上code参数
      let authorizeUrl =
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appID}&redirect_uri=` +
        `${this.host}${this.redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`

      window.location.href = authorizeUrl
    }
  }
}
</script>
<style>
input::-webkit-input-placeholder {
  color: #1debff;
  font-size: 32px;
}
input:-moz-placeholder {
  color: #1debff;
  opacity: 1;
  font-size: 32px;
}
input::-moz-placeholder {
  color: #1debff;
  opacity: 1;
  font-size: 32px;
}
input:-ms-input-placeholder {
  color: #1debff;
  font-size: 32px;
}
body {
  margin: 0;
  padding: 0;
}
@font-face {
  font-family: 'aliHYAiHei';
  src: url(../static/font/aliHYAiHei.ttf);
}
.customizeBorder {
  border: 1em double;
  border-image-source: url(../static/img/common/borderImage/border.png);
  border-image-slice: 49% 49%;
  border-image-width: 50px;
  border-image-outset: 0px;
  border-image-repeat: rounded;
}
.gradient p {
  margin: 0px;
  color: #1debff;
  font-size: 50px;
  font-family: aliHYAiHei;
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.backgroundImg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue